<template>
    <div class="pa-5 compact-form" v-if="activeUser">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "First name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeUser.first_name"
                    disabled
                    class="text-field-item mb-1"
                    dense
                    hide-details
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Last name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeUser.last_name"
                    class="text-field-item mb-1"
                    disabled
                    dense
                    hide-details
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeUser.email"
                    class="text-field-item mb-1"
                    disabled
                    dense
                    hide-details
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Position" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeUser.position"
                    class="text-field-item mb-1"
                    disabled
                    dense
                    hide-details
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Phone" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeUser.phone ? activeUser.phone : '-'"
                    class="text-field-item mb-1"
                    disabled
                    dense
                    hide-details
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3" />
        <div v-for="(item, index) in activeUser.custom_links" :key="item.title + '_' + index">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Title" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.title"
                        @input="updateCustomLinksField($event, 'title', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Active" | t }}</v-col>
                <v-col cols="6">
                    <v-checkbox
                        :value="item.is_active"
                        v-model="item.is_active"
                        @input="updateCustomLinksField($event, 'is_active', index)"
                        class="text-field-item mb-2 mt-2 pt-0"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Open in" | t }}</v-col>
                <v-col cols="6">
                    <v-select
                        :value="item.open_in"
                        @input="updateCustomLinksField($event, 'open_in', index)"
                        class="mb-1"
                        :items="openInItems"
                        placeholder="Select"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "URL" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.url"
                        @input="updateCustomLinksField($event, 'url', index)"
                        class="text-field-item mb-1"
                        hide-details
                        dense
                        outlined
                    />
                </v-col>
            </v-row>

            <v-row no-gutters justify="end" class="mr-2">
                <v-btn dark color="bal-red" class="px-2" @click.stop="deleteLink(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn dark color="bal-red" class="px-2 ml-2" @click.stop="addNewLink" style="min-width: 0;">
            <v-icon>add</v-icon><span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "user-settings-view",
    data() {
        return { openInItems: ["iframe", "new tab"] };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("UserStore", ["activeUser"])
    },
    async mounted() {
        await Store.commit("UserStore/setUserDataLoading", true);
        await Store.dispatch("getUserData");
        await Store.dispatch("UserStore/getUserData", this.user.id);
    },
    watch: {
        user: function() {
            Store.dispatch("UserStore/getUserData", this.user.id);
        }
    },
    methods: {
        updateCustomLinksField(value, field, index) {
            Store.commit("UserStore/updateActiveUserCustomLinksProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        addNewLink() {
            Store.commit("UserStore/addNewLink");
        },
        deleteLink(index) {
            if (confirm("Are you sure you want to delete this Link?")) {
                Store.commit("UserStore/deleteLink", index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
    margin-bottom: 0px;
}
.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
